// TODO: will be deprecated after filter management GA.
import featureNames from '@utils/featureToggle/constants';
import { get } from 'lodash';

export const checkIfFilterManagementEnabled = () => {
  const state = window.store ? window.store.getState() : {};
  const features = get(state, 'common.features', {});
  return features[featureNames.NEW_FILTER_MANAGEMENT] && features[featureNames.NEW_SETTING_PANEL];
};